// eslint-disable-next-line import/no-anonymous-default-export
export default {
  OnlineScreen: 'HitPaw 온라인 스크린 레코더',
  RecordScreenWithAudio:
    '화면 전체, 애플리케이션, 브라우저 탭을 음성으로 녹화할 수 있습니다.',
  ScreenOnly: '화면(녹화) 만',
  ScreenAndCam: '화면과 웹캠',
  Microphone: '마이크',
  SystemAudio: '시스템 사운드',
  StartRecording: '녹화 시작',
  NoAudioAndTryAgain:
    '사용 가능한 오디오 소스가 없습니다. <1><0>아래 설명에 따라</0></1> 다시 시도하십시오.',
  TheInstruction: '설명하다.',
  AccessMicrophone:
    "online.hitpaw.kr는 음성을 녹음하기 위해 마이크에 액세스해야 하므로 '허용'을 클릭하십시오.",
  BestScreenRecorderSoftware:
    '최고의 화면 녹화 프로그램 & 무료 동영상 스트리밍 프로그램',
  CaptureAnythingOnScreen:
    '웹 사이트, 강의, 영상 통화 및 화면 내용을 캡처하고 기록합니다.',
  RecordToShare: '게임의 최고의 순간을 기록하고 친구들과 공유합니다.',
  StreamOnFackbook:
    'Facebook, YouTube, Twitch 등에서 프로 수준의 라이브 전송이 가능합니다.',
  BringMagic: '생방송과 화상 채팅을 위한 신기한 가상 웹캠을 만들었습니다.',
  StepOne: '스텝 1: 녹화할 화면을 선택하세요.',
  StepTwo: '스텝 2 : 녹화할 화면을 선택하세요.',
  StepThree: "스텝 3: '시스템 오디오 공유'를 클릭합니다.",
  StepFour: "스텝 2: '공유'를 클릭하고 녹화를 시작합니다.",
  GrantPermission: '화면녹화 허가를 받고 다시 시도해 주세요.',
  RecordingProgress: '녹화 중...',
  MoreOptions: '추가 녹화 옵션:',
  Pause: '일시 정지',
  Continue: '계속',
  Stop: '정지',
  Webcam: '웹 카메라',
  GreenScreenAndChangeBackground: '녹색 화면 및 배경 변경',
  StreamToYouTube: 'Facebook, Twitch, YouTube 등으로 스트리밍합니다.',
  ScheduleRecording: '녹화 예약',
  NewRecording: '새 녹음',
  ExportToMp4: 'MP4에 저장',
  AddWatermark: '워터마크를 넣기',
  ChangeSpeed: '속도 변경',
  CutAndTrim: '커트&트림',
  '120XDownload': '120배속 동영상 변환 및 HD 동영상 다운로드 프로그램',
  CovertAudioFormats:
    '동영상 및 음성 파일을 1,000개 이상의 형식으로 변환합니다.',
  DownloadVideoFromWebsites:
    '10,000+ 동영상 공유 사이트에서 동영상을 다운로드하여 저장할 수 있습니다.',
  BatchConvertImageAndGif:
    '이미지를 대량으로 변환하고 비디오로부터 GIF를 만듭니다.',
  RichEdingingFeatures:
    '병합, 커트, 크롭, 비침 등 풍부한 동영상 편집 기능 내장되어 있습니다.',
  BestVideoEditor:
    '다목적으로 사용할 수 있는 최고의 동영상 편집 프로그램입니다.',
  MakeSimpleEdits:
    '복잡한 편집을 쉽게 하는 수많은 상을 받은 동영상 편집 프로그램입니다.',
  BeyondImaginationMaterials:
    '상상을 초월하는 다채로운 내장 및 온라인 소재가집니다.',
  AqualityVideoMaker:
    '품질 지향 비디오 제작자는 1080P/4K 비디오를 완전히 무료로 내보내고 공유할 수 있습니다.',
  WorkOnAnywhere:
    '성능에 영향을 주지 않고 모든 PC에서 안전하게 실행할 수 있습니다.',
  RecordCompleted: '녹화 완료',
  Download: '다운로드',
  YouMayNeed: '필요할 수도 있습니다.',
  TryItFree: '무료 체험',
  AlreadyHaveAccount: '이미 계좌번호가 있습니까?',
  LoginNow: '지금 로그인',
  exceedTenMin: '10분간의 녹음 시간은 종료되었습니다.',
  UpgradeToRecord: '녹화를 계속하려면 업그레이드하십시오.',
  ScreenProFeature: 'HitPaw 온라인 녹화 프로의 기능을 이용합니다.',
  FreeScreenAccount: '무료 계정 녹화 시간은 <1><0>10</0></1>분뿐입니다.',
  BuyNow: '지금 구입',
  DownloadMp4: 'MP4로 다운로드하세요.',
  FreeDownload: '무료 다운로드',
  DownloadTenMin: '다운로드 10분.',
  FullVideo: '풀타임',
  FormatMp4: 'MP4로 다운로드하세요.',
  Downloading: '다운로드 중...',
  DownloadFailed: '다운로드에 실패했습니다. 다시 시도해 보세요.',
  DownloadSuccess: '다운로드에 성공했습니다!',
  Exceed100MDownloadConvert:
    'MP4 형식의 동영상을 다운로드 할 경우 동영상 크기는 100MB를 초과할 수 없습니다. HitPaw Video Converter를 다운로드하여 더 많은 기능을 이용합니다.',
  Exceed30Min:
    'MP4 형식의 동영상을 다운로드 할 경우 동영상 길이는 30분을 초과할 수 없습니다. HitPaw Video Converter를 다운로드하여 더 많은 기능을 이용합니다.',
  Week: '주',
  Month: '월',
  Year: '년',
  BilledMonthly: '월',
  BilledAnnually: '월',
  ConvertText1:
    '크기 제한 없는 대용량 파일의 대량 처리를 위한 데스크톱 버전 다운로드',
  ConvertText2:
    '비디오 및 오디오 파일을 120배 빠른 속도로 1000개 이상의 형식으로 대량 변환',
  ConvertText3:
    'YouTube, TikTok, Instagram 등과 같은 10000 개 이상의 웹 사이트에서 비디오를 다운로드하고 저장합니다.',
  ConvertText4: 'Apple Music을 DRM이 제거된 MP3로 변환(Windows 버전에만 해당)',
  TenMinUp: '10분간의 녹음 시간은 종료되었습니다.',
  UpgradeMore: '녹화를 계속하려면 업그레이드하십시오.',
  NoRecordLimit: '화면 녹화 시간 제한이 없습니다.',
  NoRecordNumLimit: '녹음 수에는 제한이 없습니다.',
  DownloadVideoMP4: '비디오를 MP4로 다운로드하세요.',
  MonthOff: '60% OFF',
  YearOff: '80% OFF',
  UpgradeNow: '지금 업그레이드',
  CheckConnect: '인터넷 연결을 확인한 후 다시 시도하십시오.',
};
